import {
  ADD_CNPB_AND_PLAN_NAME,
  ADD_DRAFT_ITEM,
  ALTERAR_PLANO_USUARIO_REQUEST,
  ATUALIZAR_DADOS_CADASTRAIS_REQUEST,
  CREATE_DRAFT_REQUEST,
  DADOS_PESSOAIS_SUCCESS,
  DELETE_DRAFT_ITEM,
  FALE_CONOSCO_REQUEST,
  FINISH_FORM,
  FORMULARIO_ENVIADO,
  FORMULARIO_RESET,
  FORM_REQUEST,
  GERAR_PROTOCOLO_REQUEST,
  GERAR_PROTOCOLO_SUCCESS,
  OBTER_PAGINAS_DISPONIVEIS_EXTRATO_REQUEST,
  OBTER_PAGINAS_DISPONIVEIS_EXTRATO_SUCCESS,
  OBTER_PENDENCIAS_USUARIO_REQUEST,
  OBTER_PENDENCIAS_USUARIO_SUCCESS,
  REQUEST_ERROR,
  REQUEST_SOLICITACAO_DE_EMPRESTIMO,
  RESET_USER,
  UPDATE_ATTACHMENT_REQUEST,
  UPDATE_DRAFT,
  UPDATE_DRAFT_ITEM,
  USER_AUTHADM_REQUEST,
  USER_AUTHADM_SUCCESS,
  USER_AUTH_REQUEST,
  USER_AUTH_SUCCESS,
  USER_DATA_REQUEST,
  USER_DATA_SUCCESS,
  USER_LOGOUT_REQUEST,
  USER_LOGOUT_SUCCESS,
} from './constants';

export function logaUsuarioRequest(values) {
  return {
    type: USER_AUTH_REQUEST,
    values,
  };
}

export function logaUsuarioSuccess(values) {
  return {
    type: USER_AUTH_SUCCESS,
    values,
  };
}

export function logaUsuarioADMRequest(values) {
  return {
    type: USER_AUTHADM_REQUEST,
    values,
  };
}

export function logaUsuarioADMSuccess(values) {
  return {
    type: USER_AUTHADM_SUCCESS,
    values,
  };
}

export function deslogaUsuarioRequest() {
  return {
    type: USER_LOGOUT_REQUEST,
  };
}

export function deslogaUsuarioSuccess() {
  return {
    type: USER_LOGOUT_SUCCESS,
  };
}

export function atualizaStateRequest(values) {
  return {
    type: USER_DATA_REQUEST,
    values,
  };
}

export function atualizaStateSuccess(values) {
  return {
    type: USER_DATA_SUCCESS,
    values,
  };
}

export function obterPendenciasUsuarioRequest(values) {
  return {
    type: OBTER_PENDENCIAS_USUARIO_REQUEST,
    values,
  };
}

export function obterPendenciasUsuarioSuccess(values) {
  return {
    type: OBTER_PENDENCIAS_USUARIO_SUCCESS,
    values,
  };
}

export function requestError(values) {
  return {
    type: REQUEST_ERROR,
    values,
  };
}

export function enviaFormRequest({ campos, formulario, navigate, salvar }) {
  return {
    type: FORM_REQUEST,
    campos,
    formulario,
    navigate,
    salvar,
  };
}

export function dadosPessoaisSuccess(dadosPessoais) {
  return {
    type: DADOS_PESSOAIS_SUCCESS,
    dadosPessoais,
  };
}

export function formularioEnviado(formulario) {
  return {
    type: FORMULARIO_ENVIADO,
    formulario,
  };
}

export function formularioReset() {
  return {
    type: FORMULARIO_RESET,
  };
}

export function alterarPlanoOuUsuarioRequest(values) {
  return {
    type: ALTERAR_PLANO_USUARIO_REQUEST,
    values,
  };
}

export function gerarProtocoloRequest() {
  return {
    type: GERAR_PROTOCOLO_REQUEST,
  };
}

export function gerarProtocoloSuccess({ protocolo }) {
  return {
    type: GERAR_PROTOCOLO_SUCCESS,
    protocolo,
  };
}

export function criaFormRascunhoRequest(formulario) {
  return {
    type: CREATE_DRAFT_REQUEST,
    formulario,
  };
}

export function atualizaFormRascunho(lista) {
  return {
    type: UPDATE_DRAFT,
    lista,
  };
}

export function adicionaItemRascunhoRequest({ campos, successMessage }) {
  return {
    type: ADD_DRAFT_ITEM,
    campos,
    successMessage,
  };
}

export function atualizaItemRascunhoRequest({
  campos,
  camposAntigos,
  successMessage,
}) {
  return {
    type: UPDATE_DRAFT_ITEM,
    campos,
    camposAntigos,
    successMessage,
  };
}

export function excluiItemRascunhoRequest(campos) {
  return {
    type: DELETE_DRAFT_ITEM,
    campos,
  };
}

export function concluirFormRequest(formulario) {
  return {
    type: FINISH_FORM,
    formulario,
  };
}

export function enviaAnexoComplementarRequest({ anexo, protocolo }) {
  return {
    type: UPDATE_ATTACHMENT_REQUEST,
    anexo,
    protocolo,
  };
}

export function addCnpbAndPlanName({ plano, cnpb }) {
  return {
    type: ADD_CNPB_AND_PLAN_NAME,
    plano,
    cnpb,
  };
}

export function obterPaginasDisponiveisExtratoRequest() {
  return {
    type: OBTER_PAGINAS_DISPONIVEIS_EXTRATO_REQUEST,
  };
}

export function obterPaginasDisponiveisExtratoSuccess(payload) {
  return {
    type: OBTER_PAGINAS_DISPONIVEIS_EXTRATO_SUCCESS,
    payload,
  };
}

export function atualizarDadosCadastraisRequest({ values, openModalError }) {
  return {
    type: ATUALIZAR_DADOS_CADASTRAIS_REQUEST,
    values,
    openModalError,
  };
}

export function enviaSimulacaoEmprestimo(campos, anexos) {
  return {
    type: REQUEST_SOLICITACAO_DE_EMPRESTIMO,
    campos,
    anexos,
  };
}

export function resetaUser() {
  return {
    type: RESET_USER,
  };
}

export function faleConoscoRequest(campos) {
  return {
    type: FALE_CONOSCO_REQUEST,
    payload: campos,
  };
}
